import { render, staticRenderFns } from "./PieChartTeacher.vue?vue&type=template&id=e27db29c&"
import script from "./PieChartTeacher.vue?vue&type=script&lang=js&"
export * from "./PieChartTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports